// Redux Actions
import {
  INIT_CART_ID,
  INIT_CART_COUNTER,
  SET_CART_COUNTER,
  SET_CART_ITEMS,
  ADD_CART_ITEMS,
  REMOVE_CART_ITEMS
} from "../types";

export function initCartID(payload) {
  return { type: INIT_CART_ID, payload }
};

export function initCartCounter(payload) {
  return { type: INIT_CART_COUNTER, payload }
};

export function setCartCounter(payload) {
  return { type: SET_CART_COUNTER, payload }
};

export function setCartItems(payload) {
  return { type: SET_CART_ITEMS, payload }
};

export function addCartItems(payload) {
  return { type: ADD_CART_ITEMS, payload }
};

export function removeCartItems(payload) {
  return { type: REMOVE_CART_ITEMS, payload }
};
